import { Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './contexts/AuthContext';

// Page components
import HomePage from './pages/HomePage';
import ProductAnalysis from './pages/ProductAnalysis';
import ComponentDetail from './pages/ComponentDetail';
import DynamicComponentDetail from './pages/DynamicComponentDetail';
import ProcessDetail from './pages/ProcessDetail';
import AdminDashboard from './pages/AdminDashboard';
import AdminFeedback from './pages/AdminFeedback';
import SearchPage from './pages/SearchPage';
import NotFoundPage from './pages/NotFoundPage';
import LoginPage from './pages/LoginPage';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import UpgradePage from './pages/UpgradePage';
import TariffAnalysisPage from './pages/TariffAnalysisPage';
import ReshoringAnalysisPage from './pages/ReshoringAnalysisPage';

// Components
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  return (
    <AuthProvider>
      <Routes>
        {/* Public routes */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<TermsOfService />} />
        <Route path="/upgrade" element={<UpgradePage />} />
        
        {/* Home page */}
        <Route path="/" element={<HomePage />} />
        
        {/* Search results */}
        <Route path="/search" element={<SearchPage />} />
        
        {/* Product routes */}
        <Route path="/products/:productSlug" element={<ProductAnalysis />} />
        <Route path="/products/:productSlug/tariff-analysis" element={<TariffAnalysisPage />} />
        <Route path="/products/:productSlug/reshoring-analysis" element={<ReshoringAnalysisPage />} />
        
        {/* Generic component routes */}
        <Route path="/components/:componentSlug" element={<ComponentDetail />} />
        
        {/* Dynamic component routes - handles unlimited levels (catch-all) */}
        <Route path="/products/:productSlug/components/*" element={<DynamicComponentDetail />} />
        
        {/* Process routes */}
        <Route path="/processes/:processSlug" element={<ProcessDetail />} />
        
        {/* Admin routes - protected */}
        <Route path="/admin" element={
          <ProtectedRoute requireAdmin>
            <AdminDashboard />
          </ProtectedRoute>
        } />
        <Route path="/admin/feedback" element={
          <ProtectedRoute requireAdmin>
            <AdminFeedback />
          </ProtectedRoute>
        } />
        
        {/* 404 page */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>

      {/* Toast notifications */}
      <Toaster 
        position="top-right"
        toastOptions={{
          duration: 4000,
          style: {
            background: '#363636',
            color: '#fff',
          },
        }}
      />
    </AuthProvider>
  );
}

export default App; 